/**
 * Servizio per tracciare gli ultimi inserimenti localmente
 * Salva in localStorage e si aggiorna automaticamente quando un utente inserisce un punto vendita
 */

export interface LocalInsertion {
  promoName: string;
  province: string;
  timestamp: number;
}

const STORAGE_KEY = 'affarefatto_latest_insertions';
const MAX_INSERTIONS = 10;

/**
 * Ottiene gli ultimi inserimenti dal localStorage
 */
export const getLatestInsertions = (): LocalInsertion[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    
    const insertions: LocalInsertion[] = JSON.parse(stored);
    
    // Filtra inserimenti vecchi (più di 24 ore)
    const dayAgo = Date.now() - 24 * 60 * 60 * 1000;
    return insertions.filter(i => i.timestamp > dayAgo);
  } catch {
    return [];
  }
};

/**
 * Aggiunge un nuovo inserimento alla lista
 */
export const addInsertion = (promoName: string, province: string): void => {
  try {
    const insertions = getLatestInsertions();
    
    // Aggiungi il nuovo inserimento all'inizio
    const newInsertion: LocalInsertion = {
      promoName,
      province,
      timestamp: Date.now()
    };
    
    // Mantieni solo gli ultimi MAX_INSERTIONS
    const updated = [newInsertion, ...insertions].slice(0, MAX_INSERTIONS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    
    // Dispatch evento custom per aggiornare i componenti in ascolto
    window.dispatchEvent(new CustomEvent('insertion-added', { detail: newInsertion }));
  } catch (error) {
    console.error('Error saving insertion:', error);
  }
};

/**
 * Pulisce tutti gli inserimenti
 */
export const clearInsertions = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
